import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './ResendTimerMessage.scss';

class ResendTimerMessage extends React.Component {
  render() {
    const { timeLeft, translate } = this.props;
    return (
      <div className={styles.resendTimer}>
        <p>
          <span>
            {translate('authenticationPage', 'didNotGetSms')}
          </span>
          &nbsp;
          <span>
            {translate('authenticationPage', 'tryAgainIn')}
          </span>
          &nbsp;
          {timeLeft}
          &nbsp;
          <span>{translate('authenticationPage', 'seconds')}</span>
        </p>
      </div>
    );
  }
}

ResendTimerMessage.propTypes = {
  translate: PropTypes.func.isRequired,
  timeLeft: PropTypes.number
};

export default ResendTimerMessage;
